import React, { Component } from 'react';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import './YantraDetail.css';

const PDF_PRICE = '4.99';

function Square(props) {
  const id="btndiv"+props.id;
  const selid=props.selid;
  const btnid = "id"+props.id;
  // Previously this also matched `selid + 1` to fake a sliding highlight
  // animation between adjacent cells while the removed scroll-jack carousel
  // was mid-transition (via a translateX offset). Selection is now a plain
  // click, so only the single selected cell should highlight.
  const class_name = props.id === selid ? "btn-div active" : "btn-div";

  return (
    <button className="square" id={btnid}>
        <div className={class_name} id={id} onClick={props.onClick} >
        </div>
        <span id={id} onClick={props.onClick}>{props.value}
        </span>
    </button>
    );
}

class Board extends React.Component {

  renderSquare(i) {
    const value = this.props.data.yantra[i].cellValue;
    return (
      <Square
        id={i}
        value={value}
        selid={this.props.selid}
        onClick={this.props.onClick}
      />
    );
  }

  render() {
    return (
      <div className="detail_tb">
        <div className="board-row">
          {this.renderSquare(0)}
          {this.renderSquare(1)}
          {this.renderSquare(2)}
          {this.renderSquare(3)}
        </div>
        <div className="board-row">
          {this.renderSquare(4)}
          {this.renderSquare(5)}
          {this.renderSquare(6)}
          {this.renderSquare(7)}
        </div>
        <div className="board-row">
          {this.renderSquare(8)}
          {this.renderSquare(9)}
          {this.renderSquare(10)}
          {this.renderSquare(11)}
        </div>
        <div className="board-row">
          {this.renderSquare(12)}
          {this.renderSquare(13)}
          {this.renderSquare(14)}
          {this.renderSquare(15)}
        </div>
      </div>
    );
  }
}

function DetailDescriptions(props) {
  const cells = props.data.yantra;
  const items = [];

  cells.forEach((cell, index) => {
    if (index > 2) {
      const isActive = index === props.activeKey;
      items.push(
        <div
          className={isActive ? "detail-text active" : "detail-text"}
          id={index}
          key={index}
        >
          <span className="about_subtitle">
            <span className="ab_number">{cell.cellValue}</span>
            {cell.cellTitle}
          </span>
          <p className="des_yan">{cell.cellComment}</p>
        </div>
      );
    }
  });

  return <div className="text-area">{items}</div>;
}

class YantraDetailForm extends Component {

  constructor(props) {
    super(props);
    this.state = {
      yantraResult : this.props.yantraResult,
      key: 3,
      redirect: false,
      months : ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
      days : ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'],
      showPaypal: false,
      paymentError: false,
      generatingPdf: false,
    }

    this.handleChange = this.handleChange.bind(this);
    this.pdfContentRef = null;
  }

  componentWillUnmount() {
      this.unmounted = true;
  }

  handleChange(event) {
    let key = parseInt(event.target.id.replace('btndiv',''), 10);
    if (key === 0 || key === 1 || key === 2) key = 3;
    this.setState({key: key});

    const target = document.getElementById(String(key));
    if (target && target.scrollIntoView) {
        target.scrollIntoView({behavior: 'smooth', block: 'start'});
    }
  }

  // Opens the payment overlay and, once it's in the DOM, mounts the PayPal
  // button into it. Kept as a separate step from render() because the PayPal
  // SDK renders itself imperatively into a container element. If the user
  // already paid for this Yantra from the mobile app (boughtYantra.mobilePayed),
  // the PDF is already covered, so skip payment entirely and generate it.
  openPdfPayment = () => {
    if (this.state.yantraResult.boughtYantra.mobilePayed) {
        this.generatePdf();
        return;
    }
    this.setState({showPaypal: true, paymentError: false}, this.renderPaypalButtons);
  }

  closePdfPayment = () => {
    const container = document.getElementById('pdf-paypal-button-container');
    if (container) container.textContent = '';
    this.setState({showPaypal: false, paymentError: false});
  }

  renderPaypalButtons = () => {
    if (!window.paypal) {
        this.setState({paymentError: true, showPaypal: false});
        return;
    }
    const self = this;
    window.paypal.Buttons({
        createOrder: function(data, actions) {
            return actions.order.create({
                purchase_units: [{
                    custom_id: self.state.yantraResult.boughtYantra.id,
                    amount: {
                        value: PDF_PRICE
                    }
                }]
            });
        },
        onApprove: function(data, actions) {
            return actions.order.capture().then(function() {
                const url = process.env.REACT_APP_API_BASE_URL + '/paypal/prod/transaction-complete/' + data.orderID;
                return fetch(url, {
                    method: 'post',
                    headers: {
                        'Authorization': localStorage.getItem('y_jwt_token')
                    }
                })
                .then((response) => {
                    if (!response.ok) {
                        throw new Error('Could not confirm payment');
                    }
                    return response.text();
                })
                .then((text) => {
                    if (text === 'false') {
                        throw new Error('Payment refused');
                    }
                    if (self.unmounted) return;
                    self.setState({showPaypal: false});
                    self.generatePdf();
                })
                .catch(() => {
                    if (self.unmounted) return;
                    self.setState({paymentError: true});
                });
            });
        },
        onError: function() {
            self.setState({paymentError: true});
        }
    }).render('#pdf-paypal-button-container');
  }

  // Renders the on-screen content (header, grid, descriptions) into a canvas
  // and drops that image into a multi-page A4 PDF, so the download matches
  // what's currently shown on the page.
  generatePdf = () => {
    const element = this.pdfContentRef;
    if (!element) return;

    this.setState({generatingPdf: true});

    html2canvas(element, {scale: 2, useCORS: true, backgroundColor: '#ffffff'})
        .then((canvas) => {
            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF('p', 'pt', 'a4');
            const pageWidth = pdf.internal.pageSize.getWidth();
            const pageHeight = pdf.internal.pageSize.getHeight();
            const imgWidth = pageWidth;
            const imgHeight = (canvas.height * imgWidth) / canvas.width;
            let heightLeft = imgHeight;
            let position = 0;

            pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
            heightLeft -= pageHeight;

            while (heightLeft > 0) {
                position -= pageHeight;
                pdf.addPage();
                pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
                heightLeft -= pageHeight;
            }

            pdf.save('my-yantra.pdf');
            if (!this.unmounted) this.setState({generatingPdf: false});
        })
        .catch(() => {
            if (!this.unmounted) this.setState({generatingPdf: false, paymentError: true});
        });
  }

  render() {
    const key = this.state.key;
    const date = this.state.yantraResult.boughtYantra.month +' '+this.state.yantraResult.boughtYantra.day+' '+this.state.yantraResult.boughtYantra.year;
    const birthday = new Date(date);
    const day1 = birthday.getDay();
    return (
          <div className="form-div yantra">
              <div className="yantra-pdf-content" ref={(el) => { this.pdfContentRef = el; }}>
                  <div className="detail-header">
                        <h1>Your Personal Yantra </h1>
                        <p>Carefully calculated, based on your Date of Birth of {this.state.days[day1]}, {this.state.yantraResult.boughtYantra.day} {this.state.months[this.state.yantraResult.boughtYantra.month - 1]} {this.state.yantraResult.boughtYantra.year}</p>
                  </div>
                  <div>
                    <Board data={this.state.yantraResult} selid={key} onClick={this.handleChange}/>
                  </div>
                  <DetailDescriptions data={this.state.yantraResult} activeKey={key}/>
              </div>

              <div className="pdf-download-section">
                  <button
                      type="button"
                      className="form-btn yantra"
                      disabled={this.state.generatingPdf}
                      onClick={this.openPdfPayment}
                  >
                      {this.state.generatingPdf
                          ? 'PREPARING YOUR PDF…'
                          : this.state.yantraResult.boughtYantra.mobilePayed
                              ? 'DOWNLOAD PDF'
                              : `DOWNLOAD PDF – €${PDF_PRICE}`}
                  </button>
                  {this.state.paymentError &&
                      <p className="pdf-error">* Payment could not be completed. Please try again.</p>
                  }
              </div>

              {this.state.showPaypal &&
                  <div className="pdf-payment-overlay">
                      <div className="pdf-payment-box">
                          <button type="button" className="pdf-payment-close" onClick={this.closePdfPayment} aria-label="Close">×</button>
                          <p>Pay €{PDF_PRICE} to download your Yantra as a PDF</p>
                          <div id="pdf-paypal-button-container"></div>
                      </div>
                  </div>
              }
          </div>
    )
  }
}

export default YantraDetailForm;



// WEBPACK FOOTER //
// ./src/components/YantraDetail/YantraDetailForm.js